<template>
  <BaseModal :model-value="true" ariaLabel="New patient visit" @close="onCancel" >
    <template #header>
      <div class="modal-title">

        <!-- addPatient STEP HEADER -->
        <template v-if="step === 'addPatient'">
          <h4>
            New Patient Registration
          </h4>
        </template>

        <!-- FORM STEP HEADER -->
        <template v-else>
          <h4><i class="fa-solid fa-user"></i> New Encounter</h4>
          <p>Configure encounter details</p>
        </template>

      </div>
    </template>

    <div class="modal-body">
      <!-- STEP 1 — addPatient -->
      <div v-if="step === 'addPatient'">
        <div class="row">
          <div class="input-group w-50">
            <label for="patientName" class="input-label">Patient Name</label>
            <input v-model="ehrPatientName" id="patientName" type="text" required placeholder="Enter patient name" class="form-control w-100" :disabled="!!selectedPatient" />
          </div>
          <div class="input-group w-50">
            <label for="phoneNumber" class="input-label">Phone Number</label>
            <input v-model="phoneNumber" id="phoneNumber" type="text" required placeholder="Enter Phone Number" class="form-control w-100" :disabled="!!selectedPatient" />
          </div>
        </div>
        <div class="row">
          <div class="input-group w-50">
            <label for="DOB" class="input-label">Date of Birth</label>
            <input v-model="ehrPatientDOB"  :max="maxBirthDate" @focus="preventOldYears" id="DOB" type="date" required placeholder="Enter Date of Birth" class="form-control w-100" :disabled="!!selectedPatient"/>
          </div>
        </div>
      </div>

      <!-- STEP 2 — FORM -->
      <div v-else>
        <div class=" selected-patient-summarycard  p-4 mt-4">
      
        <h6>Selected patient</h6>
        <div class="card">
          <p>{{ selectedPatient.name }}</p>
          <small>{{ selectedPatient.phone_number }} DOB:{{ selectedPatient.date_of_birth }}</small>
        </div>
          <h6>Selected patient</h6>
        <div class="row">
           <div class="input-group w-50">
            <label for="encounterMode" class="input-label">Encounter Mode</label>
            <select v-model="encounterMode" id="encounterMode" class="form-select w-100">
              <option value="online">Online</option>
              <option value="offline">Offline</option>
            </select>
          </div>
          <div class="input-group w-50">
            <label for="DOC" class="input-label">Date of Complaint</label>
            <input v-model="DOC" id="DOC" type="date" required placeholder="Enter Date of Complaint" class="form-control w-100 w-100" />
          </div>
        </div>
        <div class="row">
          <div class="input-group w-50">
            <label for="DOS" class="input-label">Date of Service</label>
            <input v-model="DOS" id="DOS"   type="date" required placeholder="Enter Date of Service" class="form-control w-100 w-100" />
          </div>
          <div class="input-group w-50">
            <label for="doctorName" class="input-label">Doctor Name</label>
            <input v-model="doctorName" id="doctorName" type="text" required placeholder="Enter Doctor name" class="form-control w-100 w-100" />
          </div>
        </div>
        <div class="row">
         
        </div>
        <div class="route-options">
          <label for="route-radio" class="mb-2">Language configurations</label> 
          <div class="route-label card p-2 d-flex justify-content-center">
            <input type="radio" v-model="selectedRoute"  value="record" class="route-radio form-check-input " checked/>
            <span class="ms-3">Single language</span>
          </div>
          <div class="route-label card p-2 d-flex justify-content-center">
            <input type="radio" v-model="selectedRoute" value="translate" class="route-radio form-check-input" />
            <span class="ms-3">Multi language</span> 
          </div>
        </div>
        <div v-if="selectedRoute === 'translate'" class="language-selection row mb-2" >
          <div class="input-group w-50 d-flex flex-column">
            <label for="doctor-language">Doctor Language</label>
            <select v-model="doctorLanguage" id="doctor-language" class="form-select w-100">
              <option value="en">English</option>
              <option value="es">Spanish</option>
            </select>
          </div>
          <div class="input-group w-50 d-flex flex-column">
            <label for="patient-language">Patient Language</label>
            <select v-model="patientLanguage" id="patient-language" class="form-select w-100">
              <option value="en">English</option>
              <option value="es">Spanish</option>
            </select>
          </div>
        </div>
        <div>
          <!-- <button @click="handleSubmit" :disabled="!ehrPatientName || !selectedRoute || !ehrPatientDOB" class="submit-btn ">Start</button> -->
        </div>
      </div>

        <form @submit.prevent="handleSubmit">

        </form>
      </div>

    </div>

    <!-- FOOTER -->
    <template #footer>
      <div class="modal-footer">
   <template v-if="step === 'addPatient'">
      <button class="btn btn-outline-dark" @click="onCancel">Cancel</button>

      <button
        class="btn btn-primary"
        :disabled="!canCreatePatient"
        @click="continueToEncounter"
      >
        Continue
      </button>
    </template>
         <template v-else>
      <button class="btn btn-secondary" @click="backToSearch">Back</button>

      <button class="btn btn-outline-dark" @click="onCancel">Cancel</button>
        <button
          v-if="step === 'form'"
          class="btn btn-primary"
          :disabled="!canSubmit || isSubmitting"
          @click="handleSubmit"
        >
          {{ isSubmitting ? 'Starting...' : 'Start' }}
        </button>
 </template>
      </div>
    </template>

  </BaseModal>
</template>

<script setup>
import { ref, computed, nextTick } from 'vue'
import BaseModal from '@/components/ui/BaseModal.vue'
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { useToast } from 'vue-toastification';
import { useWebSocket } from '../../utils/useWebSocket';
import { addPatientService } from "@/services/api/patientService";
import { getNewTopicIdService } from "@/services/api/encounterService"
// eslint-disable-next-line
const props = defineProps({
  fetchPatients: { type: Function, required: true }
})
// eslint-disable-next-line
const emit = defineEmits(['close'])

const step = ref('addPatient')
const phoneNumber = ref('')
const patients = ref([])

const selectedPatient = ref(null)
const selectedPatientId = ref(null)

const doctorName = localStorage.getItem('username') || ref('');
const store = useStore();
const selectedRoute = ref('record');
const doctorLanguage = ref('en'); 
const patientLanguage = ref('es'); 
const token = localStorage.getItem('token');
const webSocket = ref(null);
const router = useRouter();
const route = useRoute();
const toast = useToast();
const DOS = new Date().toISOString().slice(0, 10);
const DOC = ref('');

const encounterMode = ref('online');
const ehrEncounterId =  route.query.ehrEncounterId;
const ehrPatientName = route.query.ehrPatientName || ref('');
const ehrPatientDOB =  route.query.ehrPatientDOB|| ref('');
const ehrOrgName =  route.query.ehrOrgName|| ref('');
const ehrPatientId =  route.query.ehrPatientId|| ref('');

const form = ref({
  visitDate: new Date().toISOString().slice(0, 10),
  complaint: '',
  notes: ''
})
const isSubmitting = ref(false)

const maxBirthDate  = computed(() => {
  const today = new Date();
  today.setFullYear(today.getFullYear() - 18);
  return today.toISOString().slice(0, 10); 
});

function preventOldYears(event) {
  const dateInput = event.target;
  dateInput.max = maxBirthDate.value;
}
const handleSubmit = async () => {
  if (!selectedPatientId.value) {
    const newPatient = await addPatient();
    if (!newPatient) return; 
  }

  const topicId = await getNewTopicId();
  if (!topicId) {
    toast.error('Unable to start encounter');
    return;
  }

  if (topicId) {
    const dialogId ="2";
    const doctorLang= doctorLanguage.value
    const patientLang= patientLanguage.value
    const patientNameV = ehrPatientName
    localStorage.setItem('encounterMode', encounterMode.value);
    const wsUrl  = `${process.env.VUE_APP_SOFA_WS}${topicId}/${dialogId}/${selectedPatientId.value}`;
    if (selectedRoute.value === 'record') {
        store.commit('setPatientName', patientNameV);
        store.commit('setPatientId', selectedPatientId.value);
        store.commit('setTopicId', topicId);
        store.commit('setDOB',ehrPatientDOB)
        store.commit('setDOC',DOC)
        store.commit('setDOS',DOS)
        if(ehrPatientId.value === ""){
          const data = { topicId, patientNameV, ehrPatientName, view: 'record' };
          store.dispatch('navigation/saveNavigationData', data);
          await router.push({ name: 'encounter' });
        }else{
          const data = {   patientNameV ,ehrEncounterId, ehrPatientName,ehrPatientId, ehrOrgName,view: 'record'};
          store.dispatch('navigation/saveNavigationData', data);
        await router.push({ name: 'encounter'});
        }
    } else if (selectedRoute.value === 'translate') {
      store.commit('setPatientName', patientNameV);
      store.commit('setTopicId', topicId);
      store.commit('setPatientId', selectedPatientId.value);
      store.commit('setDOB',ehrPatientDOB)
      store.commit('setDOC',DOC)
      store.commit('setDOS',DOS)
      const data = { topicId, patientNameV, doctorLang,patientLang, view: 'translate' };
      store.dispatch('navigation/saveNavigationData', data);
      await router.push({ name: 'encounter' });
    } else {
      console.warn('No matching route');
      toast.warning('No matching route');
      return;
    }
    await nextTick();
    const handleMessage = (data) => {
      console.log('Message received from WebSocket:', data);
    };
    webSocket.value = useWebSocket(wsUrl, token,handleMessage);
  }
  onSubmit()
};
const canCreatePatient = computed(() =>
  ehrPatientName &&
  phoneNumber.value &&
  ehrPatientDOB &&
  !isSubmitting.value
)
const continueToEncounter = async () => {
  isSubmitting.value = true

  const created = await addPatient()

  if (!created) {
    isSubmitting.value = false
    return
  }

  selectedPatient.value = created
  selectedPatientId.value = created.patient_id

  step.value = 'form'

  isSubmitting.value = false
}

const addPatient = async () => {
  const patientData = {
    name: ehrPatientName.value,
    date_of_birth: ehrPatientDOB.value,
    phone_number: phoneNumber.value,
  };
  const created = await addPatientService(patientData);

  if (!created?.patient_id) {
    console.error('No patient ID returned:', created.data);
    toast.error('Failed to add patient');
    return null;
  }

  selectedPatientId.value = created.patient_id;
  patients.value.unshift(created);
  toast.success("Patient added successfully");
  return created;
};
const getNewTopicId = async () => {
  const response = await getNewTopicIdService(ehrEncounterId);
  return response.id;
};

const backToSearch = () => {
  step.value = 'search'
}

const canSubmit = computed(() =>
  selectedPatient.value && form.value.visitDate
)

const onCancel = () => emit('close', null)

const onSubmit = () => {
  if (!canSubmit.value) return

  isSubmitting.value = true

  emit('close', {
    patient: selectedPatient.value,
    visitData: { ...form.value }
  })

  isSubmitting.value = false
}
</script>


